import script from "./transmission.vue?vue&type=script&setup=true&lang=js"
export * from "./transmission.vue?vue&type=script&setup=true&lang=js"

import "./transmission.vue?vue&type=style&index=0&id=607c0d2e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-607c0d2e"]])

export default __exports__